export default {"src":"/_next/static/media/ONB.f208ac6e.svg","height":18,"width":18};